var map = {
	"./advantage.png": 6025,
	"./antimage.png": 3097,
	"./aqua.png": 5688,
	"./archmage.png": 7066,
	"./astral.png": 2325,
	"./attuned.png": 4053,
	"./blazing.png": 1027,
	"./bloodied.png": 5174,
	"./brightening.png": 1797,
	"./calamity.png": 2710,
	"./charged.png": 5402,
	"./chosen.png": 4526,
	"./cleave.png": 4620,
	"./companion.png": 3448,
	"./competitor.png": 7430,
	"./dauntless.png": 1234,
	"./depth.png": 1209,
	"./destiny.png": 1240,
	"./dimming.png": 6611,
	"./diplomat.png": 1494,
	"./dominator.png": 7107,
	"./drunkard.png": 5217,
	"./elemental.png": 7833,
	"./equilibrium.png": 6834,
	"./farseer.png": 6260,
	"./flux.png": 8337,
	"./ghoul.png": 1157,
	"./grip.png": 7696,
	"./guardian.png": 5733,
	"./hallowed.png": 6100,
	"./harmony.png": 4756,
	"./heir.png": 9520,
	"./hurricane.png": 8347,
	"./indomitable.png": 5374,
	"./inferno.png": 411,
	"./karmic.png": 2651,
	"./kindling.png": 7102,
	"./lava.png": 7798,
	"./lifebinder.png": 2106,
	"./love.png": 1348,
	"./mystic.png": 6459,
	"./plague.png": 2130,
	"./prophet.png": 9700,
	"./radiance.png": 995,
	"./sacred.png": 6552,
	"./saint.png": 3865,
	"./sanctified.png": 2824,
	"./siphon.png": 915,
	"./solemn.png": 4802,
	"./solitude.png": 5415,
	"./soul.png": 2333,
	"./soulfire.png": 8353,
	"./storm.png": 3301,
	"./surefire.png": 2795,
	"./tranquility.png": 4660,
	"./victorious.png": 8293
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4006;